const KERALA_PATH =
  "M128 8C150 14 168 26 172 44C176 60 166 74 170 90C174 106 190 116 186 134C182 152 160 160 158 178C156 196 172 210 164 228C156 246 138 252 134 270C130 288 140 306 130 324C120 342 104 352 98 370C92 388 84 404 70 420C60 432 50 448 46 462C44 470 40 476 36 470C30 458 38 440 44 424C52 402 64 384 66 362C68 340 58 322 60 300C62 278 74 260 72 238C70 216 58 198 62 176C66 154 82 138 84 116C86 94 76 74 84 54C92 34 106 4 128 8Z";

const DOTS = [
  { n: "Kasaragod", x: 118, y: 30 }, { n: "Kannur", x: 96, y: 66 },
  { n: "Wayanad", x: 165, y: 100 }, { n: "Kozhikode", x: 80, y: 108 },
  { n: "Malappuram", x: 105, y: 150 }, { n: "Palakkad", x: 160, y: 190 },
  { n: "Thrissur", x: 95, y: 205 }, { n: "Ernakulam", x: 85, y: 250, hq: true },
  { n: "Idukki", x: 140, y: 275 }, { n: "Kottayam", x: 100, y: 295 },
  { n: "Alappuzha", x: 78, y: 300 }, { n: "Pathanamthitta", x: 110, y: 320 },
  { n: "Kollam", x: 75, y: 345 }, { n: "Thiruvananthapuram", x: 52, y: 430 },
];

export const KeralaMap = ({ tone = "dark", className = "" }) => {
  const blue = tone === "blue";
  const landFill = blue ? "rgba(59,130,246,0.08)" : tone === "dark" ? "rgba(212,175,94,0.07)" : "rgba(189,137,49,0.10)";
  const landStroke = blue ? "rgba(59,130,246,0.6)" : tone === "dark" ? "rgba(212,175,94,0.55)" : "rgba(26,26,24,0.55)";
  const dot = tone === "light" ? "#4a5568" : "#9db6d4";
  const hq = blue ? "#3b82f6" : "#d4af5e";
  return (
    <svg viewBox="0 0 220 490" className={className} role="img" aria-label="Stylised map of Kerala showing district coverage">
      <path d={KERALA_PATH} fill={landFill} stroke={landStroke} strokeWidth="1.5" />
      {DOTS.map((d) => (
        <g key={d.n}>
          {d.hq && (
            <circle cx={d.x} cy={d.y} r="9" fill="none" stroke={hq} strokeWidth="1" opacity="0.7">
              <animate attributeName="r" values="6;12" dur="2.4s" repeatCount="indefinite" />
              <animate attributeName="opacity" values="0.8;0" dur="2.4s" repeatCount="indefinite" />
            </circle>
          )}
          <circle cx={d.x} cy={d.y} r={d.hq ? 4 : 2.4} fill={d.hq ? hq : dot} />
          {d.hq && (
            <text x={d.x + 10} y={d.y + 4} fontSize="11" fill={tone === "light" ? "#1a1a18" : blue ? "#dbeafe" : "#e8dfc8"} fontFamily="inherit">
              Ernakulam · HQ
            </text>
          )}
        </g>
      ))}
    </svg>
  );
};
